const REDIRECT_URL_KEY = "redirectUrl";

export default REDIRECT_URL_KEY;
